import { DOCUMENT } from '@angular/common'
import { HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { inject, Renderer2, RendererFactory2 } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

export function redirectInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  let document = inject(DOCUMENT)
  let rendererFactory = inject(RendererFactory2)
  let renderer = rendererFactory.createRenderer(null, null)

  let interceptedRequest = req.clone()
  return next(interceptedRequest)
    .pipe(
      map(it => handleHttpResponse(renderer, document, it))
    )
}

function handleHttpResponse(
  renderer: Renderer2,
  document: Document,
  event: HttpEvent<unknown>
): HttpEvent<unknown> {
  if (event.type === HttpEventType.Response) {
    let location = event.headers.get('Location')

    if (event.status === 201 && location) {
      if (event.headers.has('Method')) {
        go(renderer, document, location, event.headers.get('Method'))
      }

      else {
        go(renderer, document, location)
      }
    }
  }

  return event
}

function go(
  renderer: Renderer2,
  document: Document,
  url: string,
  method = 'POST'
): void {
  if (method.toUpperCase() === 'POST') {
    let form = renderer.createElement('form')
    form.method = method
    form.action = url
    renderer.appendChild(document.documentElement, form)
    form.submit()
  }

  else {
    document.defaultView.location.assign(url)
  }
}
